import React from "react";
import Navigation from "@/components/Navigation";
import TermsHero from "@/components/terms/TermsHero";
import TermsContent from "@/components/terms/TermsContent";
import TermsContact from "@/components/terms/TermsContact";
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen bg-cloud-white">
      <Navigation />
      <TermsHero />
      <TermsContent />
      {/* <TermsContact /> */}
      <Footer />
    </div>
  );
};

export default Terms;
